<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Login Left-->
      <b-col
        lg="5"
        class="d-flex align-items-center flex-column auth-bg px-1 p-md-1 p-lg-3 p-xl-4 h-100"
        :class="{'justify-content-center' : activeComponent !== 'PersonalInformation' && activeComponent !== 'Password'}"
        :style="{
          background: `url(${loginBg}) top left no-repeat`,
        }"
        style="position: relative; background-size: cover !important;"
      >
        <div
          v-if="isMobile && activeComponent !== 'PersonalInformation'"
          class="login-bg-2"
        >
          <img src="@/assets/images/auth/login-bg-2.png" alt="bg">
        </div>
        <div class="auth-locale">
          <locale />
        </div>
        <!-- Brand logo-->
        <b-link class="brand-logo-login" style="z-index: 3">
          <div
            v-if="activeComponent !== backButton"
            class="back-icon"
            @click="activeComponent = backButton">
            <feather-icon
              icon="ArrowLeftIcon"
              size="2x"
              style="color: #000"
            />
          </div>
          <b-img :src="appLogoImage" width="128" />
        </b-link>
        <!-- /Brand logo-->

        <b-col
          xs="12"
          sm="8"
          md="8"
          lg="9"
          xl="12"
          style="z-index: 3"
          class="px-xl-4 flex-12-none align-items-center justify-content-center"
        >
          <KeepAlive>
            <component
              :is="activeComponent"
              :email="email"
              :phone="phone"
              :user="user"
              :password="password"
              :backButton="backButton"
              @updateActiveComponent="updateActiveComponent($event)"
              @updateBackButton="updateBackButton($event)"
              @updatePhone="updatePhone($event)"
              @updatePassword="updatePassword($event)"
              @updateEmail="updateEmail($event)"
              @updateUser="updateUser($event)"
            />
          </KeepAlive>
        </b-col>

        <!-- Sözleşme / güvenlik bağlantıları -->
        <div class="login-legal-footer">
          <app-footer
            ref="loginFooter"
            compact
          />
        </div>
      </b-col>
      <!-- /Login Left-->

      <!-- Right Text-->
      <b-col
        lg="7"
        class="d-none d-lg-flex align-items-center login-right p-0"
      >
        <div
          class="w-100 h-100 d-lg-flex align-items-center justify-content-center"
          :style="{ background: `url(${require('@/assets/images/auth/login-bg.jpg')}) center left no-repeat`, backgroundSize: 'auto' }"
        />
      </b-col>
      <!-- /Right Text-->
    </b-row>

    <!-- 18+ yaş onayı ve çerez bildirimi -->
    <login-consent @open-legal="openLegal" />
  </div>
</template>

<script>
/* eslint-disable */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BCardText, BCardTitle, BImg, BForm,
  BButton, BSpinner, VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { InfoIcon } from 'vue-feather-icons'
import SocialButtons from '@/components/auth/SocialButtons'
import Phone from '@/components/auth/Phone'
import Email from '@/components/auth/Email'
import Password from '@/components/auth/Password'
import PersonalInformation from '@/components/auth/PersonalInformation'
import ContactInformation from '@/components/auth/ContactInformation'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { gtmTrackNewEvent } from '@/helpers/helpers'
import { $themeConfig } from '@themeConfig'
import Locale from "@core/layouts/components/app-navbar/components/Locale.vue";
import AppFooter from '@core/layouts/components/AppFooter.vue'
import LoginConsent from '@/components/auth/LoginConsent.vue'
import {nextTick} from "@vue/composition-api";

const { appLogoImage } = $themeConfig.app

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    Locale,
    AppFooter,
    LoginConsent,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,

    InfoIcon,

    ContactInformation,
    Email,
    Password,
    PersonalInformation,
    Phone,
    SocialButtons,

    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      activeComponent: 'SocialButtons',
      appLogoImage: appLogoImage,
      backButton: 'SocialButtons',
      email: '',
      loading: false,
      loginBg: require('@/assets/images/auth/login-mobile3.jpg'),
      password: '',
      phone: '',
      // sideImg: require('@/assets/images/auth/login-bg.svg'),
      sideImg: require('@/assets/images/auth/login-bg.jpg'),
      windowWidth: window.innerWidth,
      user: null,

      // validation rules
      required,
    }
  },
  watch: {
    activeComponent (val) {
      if (val === 'PersonalInformation') {
        nextTick(() => {
          this.loginBg = require('@/assets/images/auth/login-mobile3.jpg')
        })
      }
      switch (val) {
        case 'Phone':
        case 'Email':
          this.backButton = 'SocialButtons'
          break;
      }
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      // if (store.state.appConfig.layout.skin === 'dark') {
      //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      //   this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
      //   return this.sideImg
      // }
      return this.sideImg
    },
    isMobile() {
        return this.windowWidth <= 991
    },
  },
  mounted() {
    // Component mount olduğunda event listener ekle
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    // Component yok edildiğinde event listener'ı temizle
    window.removeEventListener('resize', this.onResize)
  },
  created() {
    localStorage.setItem('phone', null)

    localStorage.removeItem('tempLoginToken')
  },
  methods: {
    // Yaş onayı / çerez bildirimindeki sözleşme bağlantıları giriş ekranının sözleşme penceresini açar
    openLegal(doc) {
      if (this.$refs.loginFooter) this.$refs.loginFooter.openLegal(doc)
    },
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          this.loading = true
          useJwt.login({phoneNumber: this.phone, password: this.password, lang: this.$i18n.locale})
              .then(response => {
                const defaultAbility = [
                  {
                    action: 'manage',
                    subject: 'all',
                  },
                  {
                    action: 'read',
                    subject: 'all',
                  },
                ]
                useJwt.setToken(response.data.body.loginToken.token)
                this.$store.dispatch('auth/updateUser', {
                  ability: defaultAbility,
                  ...response.data.body
                })
                this.$ability.update(defaultAbility)

                gtmTrackNewEvent('login', {
                  category: 'Login Funnel',
                  action: 'Login',
                })

                this.$router.push('/')
              })
              .catch(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('You should check your login information and try again'),
                    variant: 'danger',
                  },
                })
              })
              .finally(() => {this.loading = false})
        }
      })
    },
    onResize() {
      // Pencere boyutu değiştiğinde genişliği güncelle
      this.windowWidth = window.innerWidth
    },
    updateActiveComponent($event) {
      this.activeComponent = $event
    },
    updateBackButton($event) {
      this.backButton = $event
    },
    updateEmail($event) {
      this.email = $event
      localStorage.setItem('email', $event)
    },
    updatePhone($event) {
      this.phone = $event
      localStorage.setItem('phone', $event)
    },
    updatePassword($event) {
      this.password = $event
      localStorage.setItem('password', $event)
    },
    updateUser($event) {
      this.user = $event
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>

<style lang="scss" scoped>
.login-legal-footer {
  position: relative;
  z-index: 3;
  width: 100%;
  margin-top: 1.5rem;
}
</style>

